const manual_de = {
  title: 'Handbuch',
  loading: 'Handbuch wird geladen…',
  error: {
    title: 'Das Handbuch ist derzeit nicht verfügbar',
    description:
      'Die Hilfeseite konnte gerade nicht geladen werden. Bitte versuchen Sie es in Kürze erneut oder öffnen Sie sie in einem neuen Tab.',
    retry: 'Erneut versuchen',
  },
  external: {
    title: 'Das Handbuch öffnet sich in einem neuen Tab',
    description:
      'Unsere Hilfeseite kann derzeit nicht innerhalb von ExhibitorHub angezeigt werden. Das vollständige Handbuch sowie Tipps & Tricks finden Sie unter help.la-concept.de.',
    action: 'Handbuch öffnen',
  },
  openInNewTab: 'In neuem Tab öffnen',
}

export default manual_de
